import React from 'react';
import { NavLink, useRouteMatch } from 'react-router-dom';
import RssFeedIcon from '@mui/icons-material/RssFeed';
import FlagIcon from '@mui/icons-material/Flag';
import BarChartIcon from '@mui/icons-material/BarChart';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SecurityIcon from '@mui/icons-material/Security';
import VideocamIcon from '@mui/icons-material/Videocam';
import ViewHeadlineIcon from '@mui/icons-material/ViewHeadline';
import SettingsIcon from '@mui/icons-material/Settings';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import CrisisAlertIcon from '@mui/icons-material/CrisisAlert';
import CampaignIcon from '@mui/icons-material/Campaign';
import ListAltIcon from '@mui/icons-material/ListAlt';

export default function SidebarItem({ path, className, name }) {
  const match = useRouteMatch(path);

  const getIcon = () => {
    const iconStyle = {
      fontSize: '22px',
      marginRight: '18px',
      verticalAlign: 'middle',
      display: 'inline-block',
      color: match ? '#ED5A29' : '#777777',
      opacity: match ? 1 : 0.8
    };

    switch(name) {
      case "Summary":
        return <ViewHeadlineIcon style={iconStyle} />;
      case "Video Guides":
        return <VideocamIcon style={iconStyle} />;
      case "Install":
        return <RssFeedIcon style={iconStyle} />;
      case "Popups":
        return <FlagIcon style={iconStyle} />;
      case "Targeting":
        return <BarChartIcon style={iconStyle} />;
      case "Campaigns":
        return <CampaignIcon style={iconStyle} />;
      case "Contacts":
        return <AttachMoneyIcon style={iconStyle} />;
      case "Spam Shield":
        return <SecurityIcon style={iconStyle} />;
      case "Settings":
        return <SettingsIcon style={iconStyle} />;
      case "Help Center":
        return <HelpOutlineIcon style={iconStyle} />;
      case "Forms & Surveys":
        return <ListAltIcon style={iconStyle} />;
      default:
        return className ? (
          <i className={className} style={{ color: match ? '#ED5A29' : 'inherit' }}></i>
        ) : (
          <CrisisAlertIcon style={{ ...iconStyle, fontSize: '20px' }} />
        );
    }
  };

  return (
    <li
      key={name}
      className={match && (path !== '/' || match.isExact) ? 'active' : ''}
    >
      <NavLink to={path}>
        {getIcon()}
        <span>{name}</span>
      </NavLink>
    </li>
  );
}
